module.exports = __webpack_public_path__ + "media/fonts/galapagos-c-semibold-f3515bebf44d45feb2b660be10ff0c41.woff2";